import { Box } from '@mui/material';
import AdminMenu from 'components/@admin/AdminMenu';
import React from 'react';
import { Outlet } from 'react-router';

const AdminLayout = () => (
  <Box
    sx={{
      flexGrow: 1,
      position: 'relative',
      display: 'flex',
      overflow: 'auto',
    }}
  >
    <Box
      sx={{
        display: {
          xs: 'none',
          md: 'block',
        },
        width: 250,
        height: '100%',
      }}
    >
      <AdminMenu />
    </Box>
    <Outlet />
  </Box>
);

export default AdminLayout;
